function createEvent(eventName: string, details?: any): CustomEvent {
    if (typeof CustomEvent === 'function') {
        return new CustomEvent(eventName, {detail: details});
    }

    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, details);

    return event;
}

String.prototype.toSnake = function(): string {
    return this.replace(/[\w]([A-Z])/g, function(m) {
        return m[0] + "_" + m[1];
    }).toLowerCase();
};
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(search: string, this_len: number): boolean {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }

        return this.substring(this_len - search.length, this_len) === search;
    };
}

if (typeof IE === 'undefined' || IE) {
    const old = DOMTokenList.prototype.add;

    DOMTokenList.prototype.add = function(...args): void {
        for (const arg of args) {
            old.call(this, arg);
        }
    }
}

Number.isInteger = Number.isInteger || (value => typeof value === 'number' && isFinite(value) && Math.floor(value) === value);
Number.isNaN = Number.isNaN || (value => value !== value);
Number.prototype.toTime = function(): string {
    return Math.floor(this / 60) + ':' + ('0' + (this % 60)).slice(-2)
};

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(fun /*, thisP*/) {
        const len = this.length;

        if (typeof fun !== "function") {
            throw new TypeError();
        }

        const thisP = arguments[1];

        for (let i = 0; i < len; i++) {
            if (i in this) {
                fun.call(thisP, this[i], i, this);
            }
        }
    };
}

NodeList.prototype.forEach = NodeList.prototype.forEach || Array.prototype.forEach;
HTMLElement.prototype.remove = HTMLElement.prototype.remove || function(): void {
    if (this.parentElement)
        this.parentElement.removeChild(this);
};

if (!Element.prototype.matches) {
    // noinspection JSUnresolvedVariable
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(selector: string): HTMLElement | null {
        let el = this;

        do {
            if (el.matches(selector)) {
                return el;
            }

            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);

        return null;
    };
}

if (!Date.prototype.format) {
    Date.prototype.format = function(time, seconds) {
        let result = this.getFullYear() + '-' + ('0' + (this.getMonth() + 1)).slice(-2) + '-' + ('0' + this.getDate()).slice(-2);

        if (time || time === void 0) {
            result += ' ' + ('0' + this.getHours()).slice(-2);
            result += ':' + ('0' + this.getMinutes()).slice(-2);

            if (seconds) {
                result += ':' + ('0' + this.getSeconds()).slice(-2);
            }
        }

        return result;
    }
}

if (!HTMLElement.prototype.clear) {
    HTMLElement.prototype.clear = function () {
        while (this.lastChild) this.removeChild(this.lastChild);
        return this;
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
